import React, { Component} from 'react';
import {NavLink, Redirect} from 'react-router-dom'

import API from'../utilities/API'

//import {BrowserRouter as Router,  NavLink, Redirect  } from 'react-router-dom'

class PasswordReset extends Component {
 
constructor (props) {
    super(props);
    this.passwordResetReturn = this.passwordResetReturn.bind(this);
    this.state= {email: this.props.match.params.email, onboardid: this.props.match.params.onboardin, display:0};
 

    
    
     
}
componentDidMount = ()=> {
  //are params valid
  console.log(this.state.email, this.state.onboardid)
}
handleOnChange = event => {
  event.preventDefault();
  const { name, value } = event.target;
  
  this.setState({
    [name]: value
  });
  
}

handleSubmit = event => {
  event.preventDefault();
  if(this.validate()){
    const Reg = {
      email: this.state.email,
      password:this.state.p,
      code:this.state.onboardid,

    }
    console.log('GO GO GO GO SPEED RACER!', Reg)
  
    API.resetPassword(Reg, this.passwordResetReturn);
  }  
}
passwordResetReturn(outcome){
  if(!outcome){

  }else{
    console.log(outcome);
    switch (outcome){
      case 'Success':
        this.setState({display:1});
      break;
      default:
        this.setState({display:2});
      break;

    }
  }
}
validate(){
  
  let isValid = true;  
  
  let errorP = null;
  let errorC = null;
  if(this.state.p!==this.state.c){
    errorP="Passwords don't match.";
    errorC="Passwords don't match.";
    isValid = false;
  }
  if(this.state.p.length<=0){
    errorP = "Password can not be blank.";
    isValid = false;
  }
  
  this.setState({
    errP:errorP,
    errC: errorC})

  return isValid;
  
}

render() { 
  let regPage = ()=>(<div></div>);
  switch(this.state.display){
    case 0:
    regPage = ()=> (<div className='mypage fluid-container p-3'>
    <div className='row'>
    
    <div className='col-3' Style="min-width: 200px">
    <h2>Password Reset</h2>
    
   
    <div className='row'>
    <div className='myfldlbl col-12 mx-2'>Password</div>
    <div className='col-12 mx-2'><input className="form-control" type='password' name='p' value={this.state.p} onChange={this.handleOnChange}/></div>
    <div className='myerr col-12 mx-2'>{this.state.errP}</div>
    </div>
  
    <div className='row'>
    <div className='myfldlbl col-12 mx-2'>Confirm Password</div>
   <div className='col-12 mx-2'><input className="form-control" type='password' name='c' onChange={this.handleOnChange} value={this.state.c}/></div>
    <div className='myerr col-12 mx-2'>{this.state.errC}</div>
    </div>

    <div className='row'>
    <div className='col-12 mx-2'>
    <div className="btn btn-dark mt-2" onClick={this.handleSubmit}>Reset Password</div>
    </div>
    </div>
    
    </div>
    {/* <div className='col-9'>
    {<Privacy/>}
    </div> */}
    </div>  
    
    </div>
    );
    break;
    case 1:

     regPage = ()=> (<div><h2>Your Pasword has been updated.</h2> <NavLink to="/Login"><p>Please log in here!</p></NavLink></div>);
     break;
    default:    
      regPage = ()=> (<Redirect to="/"/>);
      break;
 
      
    
     
  }
  
  return (regPage());            
          

  
}
}

export default PasswordReset;


// WEBPACK FOOTER //
// ./src/components/PasswordReset.js